import { render, staticRenderFns } from "./Chronometer.vue?vue&type=template&id=21b85a60&"
import script from "./Chronometer.vue?vue&type=script&lang=ts&"
export * from "./Chronometer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports